import { useEffect, useState } from 'react';
import { usePageTitle } from '../../hooks/usePageTitle';
import SideBar from '../../components/global/SideBar';
import './index.css';
import SpecialistPage from '../../components/specialists/SpecialistPage';
import { Loader } from '@beholos/holoscommon';
import type { PartnerResponse } from '../../services/schedule.service';
import { fetchPartnersOfType } from '../../services/specialist.service';

export default function HealthCoach() {
  usePageTitle('Health Coach - Holos');
  const [partners, setPartners] = useState<PartnerResponse[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchData = async () => {
      setPartners(await fetchPartnersOfType('showHealthCoach'));
      setLoading(false);
    }
    fetchData();
  }, [])

  return (
    <div className="flex h-[calc(100vh-80px)] w-screen overflow-hidden">
      <div className="hidden md:block md:w-80 lg:w-96 h-full overflow-y-auto">
        <SideBar />
      </div>

      <div className="flex-1 h-full overflow-y-auto">
        {loading ? <Loader /> : <SpecialistPage
          bannerClassName="md:min-h-[auto] min-h-[calc(100vh-80px)]"
          banner={{
            title: 'Bienestar Integral Health Coach',
            subtitle:
              'Agenda una sesión 100% personalizada donde tu mentor te ayudará a elegir hábitos de un estilo de vida saludable para encontrar bienestar y mindfullness en cada ámbito de tu vida',
            imageUrl:
              'https://image.beholos.com/fit-in/1500x700/filters:quality(50)/img/fitness-pass-v2/banners/health-coach2.jpg',
            links: {
              text: 'Agendar Health Coach',
              to: 'reservar',
            },
          }}
          icons={[
            {
              icon: 'life/health-coach-icon1.svg',
              title: 'Alcanza tus objetivos',
              detail:
                'Ya sea dormir mejor, aumentar la energía, perder peso, controlar el estrés y más',
              height: 60,
            },
            {
              icon: 'life/health-coach-icon2.svg',
              title: 'Enfoque holístico',
              detail:
                'Nos enfocamos en la comida y en las áreas de tu vida que impactan tu salud general',
              height: 60,
            },
            {
              icon: 'life/health-coach-icon3.svg',
              title: 'Hábitos sostenibles',
              detail:
                'Construye hábitos que te ayuden a alcanzar el máximo bienestar día a día',
              height: 60,
            },
          ]}
          section={{
            title: 'Conoce a nuestros Health Coaches',
            description:
              'Agenda a un health coach y aprende estrategias efectivas de salud y alimentación para encontrar el equilibrio personal, familiar, profesional y hasta espiritual que necesitas. Se enviará un plan de mejoramiento de hábitos, como máximo 48 horas después de terminar la sesión. Este plan llegará por correo electrónico o el medio que le funcione mejor al profesional y al usuario.',
          }}
          specialists={partners.map(partner => ({
            id: partner._id,
            name: partner.name,
            slug: partner.slug,
            imageUrl: `https://image.beholos.com/600x500/filters:quality(90)${partner.otherStudioImages[0]}`,
            countryImageUrl: `https://cache.beholos.com${partner.country?.image}`,
            type: 'Health Coach'
          }))}
          article={{
            title: 'Visita nuestro Blog - Wellness & Meditación',
            subTitle: 'Tips para transformar tu vida hacia una existencia más placentera, saludable y feliz.'
          }}
        />}
      </div>
    </div>
  );
}
